export interface VideoItem {
  id: string;
  categoryId: string;
  title: string;
  summary: string;
  duration: string;
  views: string;
  comments: number;
  time: string;
  author: string;
  tags: string[];
  badge?: "爆" | "热";
  imageUrl: string;
}

export const videos: VideoItem[] = [
  {
    id: "v-01",
    categoryId: "yule",
    title: "热播综艺名场面盘点：这一季凭什么让全网疯狂刷屏？",
    summary: "从导师同框到即兴互怼，一次盘完这季综艺最出圈的高能瞬间，看完只想说：这季是真的会玩。",
    duration: "06:24",
    views: "238.6万",
    comments: 4821,
    time: "2小时前",
    author: "瓜田老饕",
    tags: ["综艺", "名场面", "盘点"],
    badge: "爆",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20two%20friends%20watching%20a%20glowing%20television%20in%20a%20cozy%20warm%20living%20room%20with%20popcorn%20and%20sofa%2C%20warm%20coral%20red%20amber%20and%20cream%20palette%2C%20soft%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-yule-01&orientation=landscape",
  },
  {
    id: "v-02",
    categoryId: "yule",
    title: "红毯造型大盘点：谁把氛围感拉满，谁又被网友玩梗",
    summary: "礼服、镜头、网友热评一条龙，红毯名场面背后的造型心机，带你一次看个够。",
    duration: "08:41",
    views: "156.2万",
    comments: 2315,
    time: "5小时前",
    author: "秀场雷达",
    tags: ["红毯", "造型", "时尚"],
    badge: "热",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20an%20elegant%20runway%20fashion%20scene%20with%20a%20flowing%20gown%20silhouette%20under%20golden%20spotlights%20and%20coral%20accents%2C%20warm%20amber%20and%20cream%20palette%2C%20refined%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-yule-02&orientation=landscape",
  },
  {
    id: "v-03",
    categoryId: "mingxing",
    title: "采访幕后直击：一段花絮暴露了片场最真实的相处状态",
    summary: "正片之外的花絮才是宝藏，镜头拍不到的相处细节，都被现场氛围整活了。",
    duration: "05:37",
    views: "89.4万",
    comments: 1640,
    time: "今天 09:12",
    author: "幕后探班",
    tags: ["采访", "花絮", "幕后"],
    badge: "热",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20cozy%20interview%20studio%20set%20with%20microphone%20and%20warm%20stage%20spotlights%2C%20backstage%20creative%20vibe%2C%20coral%20red%20and%20amber%20palette%20with%20soft%20cream%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-mingxing-01&orientation=landscape",
  },
  {
    id: "v-04",
    categoryId: "mingxing",
    title: "深夜路透生图流出，这个下班的背影成了网友讨论焦点",
    summary: "一张生图引发的讨论有多夸张？路透镜头下的松弛感，网友各有各的看法。",
    duration: "03:58",
    views: "203.7万",
    comments: 5910,
    time: "昨天",
    author: "站姐情报站",
    tags: ["路透", "生图", "下班路"],
    badge: "爆",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20paparazzi%20camera%20flashes%20on%20a%20quiet%20city%20night%20street%20with%20warm%20street%20lights%20and%20coral%20amber%20tones%2C%20cinematic%20moody%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-mingxing-02&orientation=landscape",
  },
  {
    id: "v-05",
    categoryId: "shehui",
    title: "暴雨中的暖心一幕：陌生人接力为公交司机撑伞",
    summary: "当镜头记录下陌生人之间的默契，平凡瞬间也能让人心头一暖，好人好事就发生在我们身边。",
    duration: "02:15",
    views: "310.2万",
    comments: 8240,
    time: "3小时前",
    author: "暖闻记录员",
    tags: ["正能量", "暖新闻", "现场"],
    badge: "热",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20warm%20community%20moments%20of%20strangers%20helping%20each%20other%20under%20soft%20sunrise%20light%2C%20coral%20amber%20and%20cream%20palette%2C%20hopeful%20cinematic%20tone%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-shehui-01&orientation=landscape",
  },
  {
    id: "v-06",
    categoryId: "shehui",
    title: "第一视角带你逛清晨菜市场，烟火气竟比大片还治愈",
    summary: "从讨价还价到现做早点，镜头里的市井烟火气，藏着这座城最真实的生活节奏。",
    duration: "07:50",
    views: "76.8万",
    comments: 1188,
    time: "昨天",
    author: "城事观察局",
    tags: ["烟火气", "城市记录", "市井"],
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20lively%20modern%20city%20street%20at%20warm%20dusk%20seen%20from%20a%20high%20viewpoint%2C%20warm%20coral%20amber%20street%20lights%20and%20cream%20sky%2C%20gentle%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-shehui-02&orientation=landscape",
  },
  {
    id: "v-07",
    categoryId: "wanghong",
    title: "百万粉丝直播间幕后：一场爆火直播是怎么准备的",
    summary: "选品、测光、话术、情绪调动，镜头外的每一个细节，都藏着直播间爆火的密码。",
    duration: "09:05",
    views: "132.5万",
    comments: 2876,
    time: "4小时前",
    author: "流量观察员",
    tags: ["直播", "幕后", "达人"],
    badge: "热",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20cozy%20mobile%20livestream%20studio%20with%20ring%20light%20and%20content%20creator%20desk%20at%20night%2C%20warm%20coral%20amber%20glow%20and%20cream%20accents%2C%20modern%20vibrant%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-wanghong-01&orientation=landscape",
  },
  {
    id: "v-08",
    categoryId: "wanghong",
    title: "深夜探店实录：街头小吃摊的老板个个是段子手",
    summary: "边吃边聊边走，跟着镜头逛一圈街，才发现市井老板才是隐藏的快乐担当。",
    duration: "11:32",
    views: "198.9万",
    comments: 4520,
    time: "昨天",
    author: "干饭研究所",
    tags: ["探店", "美食", "街头"],
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20steaming%20warm%20night%20market%20street%20food%20stall%20with%20inviting%20glow%2C%20coral%20red%20and%20amber%20palette%20on%20cream%20background%2C%20cozy%20appetizing%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-wanghong-02&orientation=landscape",
  },
  {
    id: "v-09",
    categoryId: "gaoxiao",
    title: "不服来战：这期搞笑挑战赛，笑到隔壁桌都来围观",
    summary: "从扭到脚的接力到翻车现场，本年度最搞笑的挑战合集，看一次笑一整周。",
    duration: "10:18",
    views: "412.3万",
    comments: 9872,
    time: "1小时前",
    author: "快乐发射站",
    tags: ["挑战", "翻车", "名场面"],
    badge: "爆",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20playful%20cartoon%20people%20in%20a%20funny%20running%20challenge%20with%20confetti%20and%20comic%20energy%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20bright%20cheerful%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-gaoxiao-01&orientation=landscape",
  },
  {
    id: "v-10",
    categoryId: "gaoxiao",
    title: "那些让人笑到停不下来的神反转瞬间合集",
    summary: "你以为的结尾永远不是结局，本期神反转大赏，专门专治心情不好。",
    duration: "06:47",
    views: "287.1万",
    comments: 6105,
    time: "6小时前",
    author: "段子补给站",
    tags: ["神反转", "搞笑", "合集"],
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20theatrical%20comedy%20stage%20with%20surprise%20plot%20twist%20masks%20and%20dramatic%20curtains%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20playful%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-gaoxiao-02&orientation=landscape",
  },
  {
    id: "v-11",
    categoryId: "hipai",
    title: "实拍现场：纪录片视角下的城市清晨，每一帧都是壁纸",
    summary: "用最真实的镜头语言记录城市苏醒，空镜头也能拍出大片的静谧与力量。",
    duration: "05:12",
    views: "68.3万",
    comments: 921,
    time: "8小时前",
    author: "光影记录者",
    tags: ["实拍", "纪录片", "城市"],
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20professional%20documentary%20camera%20on%20tripod%20in%20an%20outdoor%20vivid%20nature%20scene%20at%20golden%20hour%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20immersive%20cinematic%20light%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-hipai-01&orientation=landscape",
  },
  {
    id: "v-12",
    categoryId: "hipai",
    title: "神级运镜：一段航拍告诉你什么叫'上帝视角'",
    summary: "穿山越岭、云上俯冲，航拍镜头带你看地面视角永远到不了的地方。",
    duration: "04:26",
    views: "155.6万",
    comments: 2033,
    time: "昨天",
    author: "空中视角",
    tags: ["航拍", "运镜", "大片"],
    badge: "热",
    imageUrl: "https://readdy.ai/api/search-image?query=Flat%20editorial%20vector%20illustration%20of%20a%20drone%20lens%20overlooking%20grand%20aerial%20nature%20landscape%20at%20warm%20golden%20light%2C%20coral%20amber%20and%20cream%20palette%2C%20sweeping%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%2016:9%20composition&width=1200&height=675&seq=video-hipai-02&orientation=landscape",
  },
];